import { urlVars, VIDEO_STREAM_KEY } from '@repo/config';

export function buildVideoStreamUrl(localPath: string): string {
  return `${urlVars.prod.vaultUrl}/video/${VIDEO_STREAM_KEY}?path=${encodeURIComponent(localPath)}`;
}
